export enum EnterRequestAction {
    None,
    SaveRequest,
    SubmitRequest,
    CancelRequest
}